import { Button, Stack } from '@mui/material';
import React from 'react';
import { useAppContext } from '../../contexts/AppContext';
import Scrollbar from '../../components/Scrollbar';
import Buble from './Buble';
import { APP_STATE } from '../../constants/app_state';
import Iconify from '../../components/Iconify';

export default function ChatBody() {
  const scrollRef = React.useRef(null);
  const { conversations, appdispatch } = useAppContext();

  React.useEffect(() => {
    const scrollMessagesToBottom = () => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
    };
    scrollMessagesToBottom();
  }, [conversations]);

  const onClickBulleAction = (convers) => () => {
    if (convers?.children) {
      appdispatch({
        type: APP_STATE.convesation_bulle_children,
        payload: [{ ...convers, isSelected: true, isLeft: true }, ...convers.children],
      });
      return;
    }
    if (convers?.url) {
      appdispatch({
        type: APP_STATE.convesation_bulle_link,
        payload: {
          text: (
            <span>
              Consultez{' '}
              <a
                style={{ fontSize: 13, color: 'black' }}
                href={convers.url}
                target={convers?.url_type === 'ext' ? '_blank' : '_self'}
                rel="noreferrer"
              >
                {convers.text}
              </a>
              .
            </span>
          ),
          isLeft: true,
        },
      });
      return;
    }

    appdispatch({
      type: APP_STATE.convesation_bulle_note,
      payload: { text: convers?.note, isLeft: true },
    });
  };

  const onGoback = () => {
    appdispatch({
      type: APP_STATE.convesation_back,
    });
  };

  const onReset = () => {
    appdispatch({
      type: APP_STATE.conversation_init,
    });
  };

  return (
    <Scrollbar scrollableNodeProps={{ ref: scrollRef }} sx={{ p: 2, height: 0.99 }}>
      <Stack spacing={1}>
        {conversations?.map((convers, idx) => (
          <Buble
            key={convers.text + idx}
            text={convers.text}
            isLeft={convers.isLeft}
            isSelected={convers?.isSelected}
            onClick={!convers.isLeft ? onClickBulleAction(convers) : undefined}
          />
        ))}
        <Stack direction="row" spacing={0.5}>
          <Button
            variant="outlined"
            startIcon={<Iconify icon="tabler:arrow-back" />}
            sx={{ borderRadius: 1 }}
            onClick={onGoback}
          >
            Retour
          </Button>
          <Button
            variant="outlined"
            startIcon={<Iconify icon="tabler:arrow-back-up" />}
            sx={{ borderRadius: 1 }}
            onClick={onReset}
          >
            Recommencer
          </Button>
        </Stack>
      </Stack>
    </Scrollbar>
  );
}
